/**
 * @desc 根据名称获取加油站信息列表数据
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: string): Promise<BaseResponse<defs.ResultBean<Array<number>>>> {
  return fetch({
    url: config.API_HOST + '/base/resPetrolStation/findPetrolIdsByFuzzyStationName',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
